import api from "./Api";

class RelatoriosService {
  GetRelatorios(payload) {
    return api.get("/v1/relatorios/" + payload).then((response) => {
      return response.data;
    });
  }

  PostRelatorios(payload) {
    return api.post("/v1/relatorios/", payload).then((response) => {
      return response.data;
    });
  }

  PutRelatorios(payload) {
    return api.put("/v1/relatorios/", payload).then((response) => {
      return response.data;
    });
  }

  DeleteRelatorios(payload) {
    return api.delete("/v1/relatorios/" + payload).then((response) => {
      return response.data;
    });
  }

  GetRelatoriosOData(payload) {
    return api.get("/OData/Relatorios" + payload).then((response) => {
      return response.data;
    });
  }

  DownloadRelatorio(payload) {
    return api
      .get("/v1/Relatorios/DownloadRelatorio?id=" + payload)
      .then((response) => {
        return response.data;
      });
  }

  GetRelatoriosUsuario(payload) {
    return api.get("/v1/Relatorios/GetRelatoriosUsuario").then((response) => {
      return response.data;
    });
  }

  ExecutarRelatorio(payload) {
    return api
      .post("/v1/relatorios/ExecutarRelatorio/", payload)
      .then((response) => {
        return response.data;
      });
  }

  CarregarRelatorio(payload) {
    return api
      .get("/v1/relatorios/CarregarRelatorio" + payload)
      .then((response) => {
        return response.data;
      });
  }

  GetRelatorio(payload) {
    return api.post("/v1/Relatorios/GetRelatorio", payload).then((response) => {
      return response.data;
    });
  }
}

export default new RelatoriosService();
